import React from "react";

const Usd = ({ width, height, size = 24, fill = "currentColor", ...props }) => (
  <svg
    {...props}
    width={width || size}
    height={height || size}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_671_5821"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path
        d="M23.9945 12.0294C23.9945 15.2042 22.7306 18.249 20.4806 20.494C18.2307 22.7389 15.1791 24.0001 11.9973 24.0001C8.8154 24.0001 5.76385 22.7389 3.51392 20.494C1.264 18.249 0 15.2042 0 12.0294C0 8.85452 1.264 5.80971 3.51392 3.56475C5.76385 1.3198 8.8154 0.0585938 11.9973 0.0585938C15.1791 0.0585938 18.2307 1.3198 20.4806 3.56475C22.7306 5.80971 23.9945 8.85452 23.9945 12.0294Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_671_5821)">
      <path
        d="M-5.96942 18.4714H30.0109V16.6294H-5.96942V18.4714Z"
        fill="white"
      />
      <path
        d="M-5.96942 16.6294H30.0109V14.7881H-5.96942V16.6294Z"
        fill="#CA4638"
      />
      <path
        d="M-5.96942 22.153H30.0109V20.3116H-5.96942V22.153Z"
        fill="white"
      />
      <path
        d="M-5.96942 23.995H30.0109V22.153H-5.96942V23.995Z"
        fill="#CA4638"
      />
      <path
        d="M-5.96942 20.3114H30.0109V18.4714H-5.96942V20.3114Z"
        fill="#CA4638"
      />
      <path
        d="M-5.96942 14.7014H30.0109V12.8615H-5.96942V14.7014Z"
        fill="white"
      />
      <path
        d="M-5.96942 9.26497H30.0109V7.42505H-5.96942V9.26497Z"
        fill="#CA4638"
      />
      <path
        d="M-5.96942 3.74167H30.0109V1.89966H-5.96942V3.74167Z"
        fill="white"
      />
      <path
        d="M-5.96942 5.58278H30.0109V3.74146H-5.96942V5.58278Z"
        fill="#CA4638"
      />
      <path
        d="M-5.96942 12.9483H30.0109V11.1049H-5.96942V12.9483Z"
        fill="#CA4638"
      />
      <path
        d="M-5.96942 1.89959H30.0109V0.0617676H-5.96942V1.89959Z"
        fill="#CA4638"
      />
      <path
        d="M-5.96942 7.42504H30.0109V5.58301H-5.96942V7.42504Z"
        fill="white"
      />
      <path
        d="M-5.96942 11.1048H30.0109V9.26489H-5.96942V11.1048Z"
        fill="white"
      />
    </g>
    <mask
      id="mask1_671_5821"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path
        d="M24 11.9694C24 15.1438 22.7362 18.1883 20.4865 20.433C18.2368 22.6777 15.1856 23.9387 12.0041 23.9387C8.82264 23.9387 5.77145 22.6777 3.52179 20.433C1.27213 18.1883 0.00828552 15.1438 0.00828552 11.9694C0.00828552 8.79489 1.27213 5.75044 3.52179 3.50575C5.77145 1.26105 8.82264 0 12.0041 0C15.1856 0 18.2368 1.26105 20.4865 3.50575C22.7362 5.75044 24 8.79489 24 11.9694Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_671_5821)">
      <path
        d="M0.0190735 12.9565H12.0133V0.00146484H0.0190735V12.9565Z"
        fill="#356BA0"
      />
    </g>
    <path
      d="M9.19596 1.73425L9.28567 2.01234H9.57831L9.34141 2.1841L9.43309 2.46219L9.19603 2.29026L8.95716 2.46219L9.04884 2.1841L8.81193 2.01234H9.10458L9.19596 1.73425Z"
      fill="white"
    />
    <path
      d="M9.19596 4.17651L9.28567 4.45443H9.57831L9.34141 4.62636L9.43309 4.90428L9.19603 4.73433L8.95716 4.90428L9.04884 4.62636L8.81193 4.45443H9.10458L9.19596 4.17651Z"
      fill="white"
    />
    <path
      d="M9.19596 6.61987L9.28567 6.89845H9.57831L9.34141 7.06972L9.43309 7.34829L9.19603 7.17638L8.95716 7.34829L9.04884 7.06972L8.81193 6.89845H9.10458L9.19596 6.61987Z"
      fill="white"
    />
    <path
      d="M9.19596 9.1178L9.28567 9.39769H9.57831L9.34141 9.56961L9.43309 9.8495L9.19603 9.67561L8.95716 9.8495L9.04884 9.56961L8.81193 9.39769H9.10458L9.19596 9.1178Z"
      fill="white"
    />
    <path
      d="M9.19596 11.5044L9.28567 11.783H9.57831L9.34141 11.9562L9.43309 12.2341L9.19603 12.0609L8.95716 12.2341L9.04884 11.9562L8.81193 11.783H9.10458L9.19596 11.5044Z"
      fill="white"
    />
    <path
      d="M7.00012 1.73425L7.09049 2.01234H7.38445L7.14672 2.1841L7.23709 2.46219L7.0002 2.29026L6.76264 2.46219L6.85275 2.1841L6.61585 2.01234H6.9098L7.00012 1.73425Z"
      fill="white"
    />
    <path
      d="M7.00012 4.17651L7.09049 4.45443H7.38445L7.14672 4.62636L7.23709 4.90428L7.0002 4.73433L6.76264 4.90428L6.85275 4.62636L6.61585 4.45443H6.9098L7.00012 4.17651Z"
      fill="white"
    />
    <path
      d="M7.00012 6.61987L7.09049 6.89845H7.38445L7.14672 7.06972L7.23709 7.34829L7.0002 7.17638L6.76264 7.34829L6.85275 7.06972L6.61585 6.89845H6.9098L7.00012 6.61987Z"
      fill="white"
    />
    <path
      d="M7.00012 9.1178L7.09049 9.39769H7.38445L7.14672 9.56961L7.23709 9.8495L7.0002 9.67561L6.76264 9.8495L6.85275 9.56961L6.61585 9.39769H6.9098L7.00012 9.1178Z"
      fill="white"
    />
    <path
      d="M7.00012 11.5044L7.09049 11.783H7.38445L7.14672 11.9562L7.23709 12.2341L7.0002 12.0609L6.76264 12.2341L6.85275 11.9562L6.61585 11.783H6.9098L7.00012 11.5044Z"
      fill="white"
    />
    <path
      d="M4.80604 4.17651L4.89574 4.45443H5.18837L4.95148 4.62636L5.0429 4.90428L4.806 4.73433L4.56713 4.90428L4.65882 4.62636L4.42175 4.45443H4.7139L4.80597 4.17651"
      fill="white"
    />
    <path
      d="M4.80604 6.61987L4.89574 6.89845H5.18837L4.95148 7.06972L5.0429 7.34829L4.806 7.17638L4.56713 7.34829L4.65882 7.06972L4.42175 6.89845H4.7139L4.80597 6.61987"
      fill="white"
    />
    <path
      d="M4.80604 9.1178L4.89574 9.39769H5.18837L4.95148 9.56961L5.0429 9.8495L4.806 9.67561L4.56713 9.8495L4.65882 9.56961L4.42175 9.39769H4.7139L4.80597 9.1178"
      fill="white"
    />
    <path
      d="M4.80604 11.5044L4.89574 11.783H5.18837L4.95148 11.9562L5.0429 12.2341L4.806 12.0609L4.56713 12.2341L4.65882 11.9562L4.42175 11.783H4.7139L4.80597 11.5044"
      fill="white"
    />
    <path
      d="M2.60956 6.61987L2.6998 6.89845H2.99376L2.75685 7.06972L2.84722 7.34829L2.60966 7.17638L2.37259 7.34829L2.46296 7.06972L2.2254 6.89845H2.51804L2.60972 6.61987"
      fill="white"
    />
    <path
      d="M2.60956 9.1178L2.6998 9.39769H2.99376L2.75685 9.56961L2.84722 9.8495L2.60966 9.67561L2.37259 9.8495L2.46296 9.56961L2.2254 9.39769H2.51804L2.60972 9.1178"
      fill="white"
    />
    <path
      d="M2.60956 11.5044L2.6998 11.783H2.99376L2.75685 11.9562L2.84722 12.2341L2.60966 12.0609L2.37259 12.2341L2.46296 11.9562L2.2254 11.783H2.51804L2.60972 11.5044"
      fill="white"
    />
    <path
      d="M10.3149 2.9541L10.4051 3.234H10.6991L10.4615 3.40395L10.5519 3.68384L10.315 3.51208L10.0772 3.68384L10.1683 3.40395L9.9307 3.234H10.224L10.315 2.9541"
      fill="white"
    />
    <path
      d="M10.3149 5.47693L10.4051 5.75502H10.6991L10.4615 5.92678L10.5519 6.20486L10.315 6.03295L10.0772 6.20486L10.1683 5.92678L9.9307 5.75502H10.224L10.315 5.47693"
      fill="white"
    />
    <path
      d="M10.2924 7.94849L10.3834 8.22642H10.6767L10.4397 8.39833L10.53 8.67627L10.2925 8.50303L10.0556 8.67627L10.1458 8.39833L9.90826 8.22642H10.2022L10.2926 7.94849"
      fill="white"
    />
    <path
      d="M10.2706 10.3907L10.3616 10.6688H10.6556L10.4174 10.8406L10.5088 11.1187L10.2706 10.9474L10.0343 11.1187L10.1247 10.8406L9.88634 10.6688H10.1803L10.2706 10.3907Z"
      fill="white"
    />
    <path
      d="M8.11889 2.9541L8.20991 3.234H8.50387L8.26565 3.40395L8.35707 3.68384L8.11886 3.51208L7.8813 3.68384L7.97298 3.40395L7.73592 3.234H8.02855L8.11889 2.9541Z"
      fill="white"
    />
    <path
      d="M8.11889 5.47693L8.20991 5.75502H8.50387L8.26565 5.92678L8.35707 6.20486L8.11886 6.03295L7.8813 6.20486L7.97298 5.92678L7.73592 5.75502H8.02855L8.11889 5.47693Z"
      fill="white"
    />
    <path
      d="M8.09772 7.94849L8.18809 8.22642H8.48203L8.24514 8.39833L8.33538 8.67627L8.09782 8.50303L7.86092 8.67627L7.95129 8.39833L7.71357 8.22642H8.00638L8.09779 7.94849"
      fill="white"
    />
    <path
      d="M8.07591 10.3907L8.16627 10.6688H8.45957L8.22267 10.8406L8.31304 11.1187L8.07597 10.9474L7.83841 11.1187L7.92878 10.8406L7.69187 10.6688H7.98517L8.07606 10.3907"
      fill="white"
    />
    <path
      d="M5.92369 2.86768L6.01457 3.14559H6.30787L6.07097 3.31752L6.162 3.59544L5.92379 3.42368L5.68673 3.59544L5.77775 3.31752L5.54021 3.14559H5.83349L5.92386 2.86768"
      fill="white"
    />
    <path
      d="M5.92369 5.38867L6.01457 5.66659H6.30787L6.07097 5.83983L6.162 6.11644L5.92379 5.94648L5.68673 6.11644L5.77775 5.83983L5.54021 5.66659H5.83349L5.92386 5.38867"
      fill="white"
    />
    <path
      d="M5.90254 7.86023L5.99198 8.13815H6.28594L6.04838 8.31008L6.1394 8.588L5.9025 8.41608L5.66412 8.588L5.75514 8.31008L5.51823 8.13815H5.81153L5.90254 7.86023Z"
      fill="white"
    />
    <path
      d="M5.88007 10.3036L5.97109 10.5822H6.26439L6.02733 10.7521L6.11769 11.032L5.88015 10.8601L5.64324 11.032L5.73348 10.7521L5.49593 10.5822H5.78922L5.88024 10.3036"
      fill="white"
    />
    <path
      d="M3.72962 5.36377L3.81972 5.64169H4.11318L3.87546 5.81558L3.96582 6.0935L3.72958 5.92027L3.49137 6.0935L3.58279 5.81558L3.34523 5.64169H3.63853L3.72955 5.36377"
      fill="white"
    />
    <path
      d="M3.70783 7.83533L3.79754 8.11391H4.09149L3.85393 8.28714L3.94482 8.56507L3.70793 8.392L3.47037 8.56507L3.56061 8.28714L3.32372 8.11391H3.61635L3.70802 7.83533"
      fill="white"
    />
    <path
      d="M3.68533 10.2776L3.77636 10.5562H4.06964L3.8321 10.7294L3.9222 11.0073L3.68529 10.8341L3.4484 11.0073L3.53877 10.7294L3.30106 10.5562H3.59436L3.68533 10.2776Z"
      fill="white"
    />
    <path
      d="M1.51115 7.79321L1.60216 8.0713H1.89545L1.6579 8.24306L1.74893 8.52115L1.51121 8.34923L1.27432 8.52115L1.36468 8.24306L1.12714 8.0713H1.42108L1.51131 7.79321"
      fill="white"
    />
    <path
      d="M1.49015 10.2355L1.57973 10.5134H1.87368L1.63613 10.6853L1.72715 10.9633L1.49024 10.7915L1.25187 10.9633L1.34289 10.6853L1.10599 10.5134H1.39929L1.49031 10.2355"
      fill="white"
    />
    <path
      d="M11.3907 1.73425L11.4804 2.01234H11.7743L11.5374 2.1841L11.6275 2.46219L11.3906 2.29026L11.1531 2.46219L11.2435 2.1841L11.0064 2.01234H11.2997L11.3907 1.73425Z"
      fill="white"
    />
    <path
      d="M11.3907 4.17651L11.4804 4.45443H11.7743L11.5374 4.62636L11.6275 4.90428L11.3906 4.73433L11.1531 4.90428L11.2435 4.62636L11.0064 4.45443H11.2997L11.3907 4.17651Z"
      fill="white"
    />
    <path
      d="M11.3907 6.61987L11.4804 6.89845H11.7743L11.5374 7.06972L11.6275 7.34829L11.3906 7.17638L11.1531 7.34829L11.2435 7.06972L11.0064 6.89845H11.2997L11.3907 6.61987Z"
      fill="white"
    />
    <path
      d="M11.3907 9.1178L11.4804 9.39769H11.7743L11.5374 9.56961L11.6275 9.8495L11.3906 9.67561L11.1531 9.8495L11.2435 9.56961L11.0064 9.39769H11.2997L11.3907 9.1178Z"
      fill="white"
    />
    <path
      d="M11.3907 11.5044L11.4804 11.783H11.7743L11.5374 11.9562L11.6275 12.2341L11.3906 12.0609L11.1531 12.2341L11.2435 11.9562L11.0064 11.783H11.2997L11.3907 11.5044Z"
      fill="white"
    />
    <path
      d="M10.3149 0.624268L10.4051 0.902851H10.6991L10.4621 1.07608L10.5525 1.35401L10.315 1.18077L10.0779 1.35401L10.1683 1.07608L9.9307 0.902851H10.2233L10.315 0.624268"
      fill="white"
    />
    <path
      d="M0.590216 11.5044L0.680456 11.783H0.974408L0.737502 11.9562L0.827872 12.2341L0.590311 12.0609L0.353246 12.2341L0.44361 11.9562L0.206055 11.783H0.498699L0.590375 11.5044"
      fill="white"
    />
    <path
      d="M0.792163 9.1178L0.882403 9.39769H1.17635L0.939449 9.56961L1.02982 9.8495L0.792258 9.67561L0.555193 9.8495L0.645557 9.56961L0.408005 9.39769H0.700646L0.792322 9.1178"
      fill="white"
    />
    <path
      d="M8.11889 0.838501L8.20991 1.11839H8.50387L8.26565 1.28835L8.35707 1.56824L8.11886 1.39648L7.8813 1.56824L7.97298 1.28835L7.73592 1.11839H8.02855L8.11889 0.838501Z"
      fill="white"
    />
  </svg>
);

export default Usd;
